import { showConfirmationPrompt } from '@bpinternal/ui-kit-next'
import { PlanSummary } from './PlanSummary'
import { usePlanProducts } from '../hooks/usePlanProducts'
import { useAddons } from '../hooks/useAddons'
import { ProductIcon } from './ProductIcon'
import { QuotaType } from '@bpinternal/const'

type CancelSubscriptionConfirmDialogProps = {
  workspaceId: string
}

export const showCancelSubscriptionConfirmDialog = (props: CancelSubscriptionConfirmDialogProps) => {
  return showConfirmationPrompt(<CancelSubscriptionConfirmDialog {...props} />, {
    title: 'Are you sure you want to cancel?',
    confirmLabel: 'Continue',
    cancelLabel: 'Keep my subscription',
    size: 'max-w-4xl',
  })
}

const CancelSubscriptionConfirmDialog = ({ workspaceId }: CancelSubscriptionConfirmDialogProps) => {
  const { currentPlan } = usePlanProducts(workspaceId)
  const { addons } = useAddons(workspaceId)

  return (
    <div className="flex flex-col gap-6">
      <div>
        Your plan features remain available <span className="font-semibold">until this billing cycle ends. </span>After
        that, you'll lose access to:
      </div>
      {currentPlan.legacyName !== 'community' && <PlanSummary plan={currentPlan.legacyName} upgrade={false} />}
      {addons.some((addon) => addon.nextPaymentQuantity > 0) && (
        <div className="rounded-lg bg-gray-2 px-6 py-4">
          <div className="flex flex-col gap-4">
            <div className="text-muted-foreground">Your Current Add-ons</div>
            <div className="grid grid-cols-3 gap-3">
              {addons
                .filter((addon) => addon.nextPaymentQuantity > 0)
                .map((addon, index) => {
                  return (
                    <div key={index} className="flex gap-2">
                      <ProductIcon
                        productQuotaName={addon.quotaName as QuotaType}
                        className="flex-shrink-0 rounded-lg bg-blue-8 p-1 text-white"
                      />
                      <div className="text-muted-foreground">{addon.displayName}</div>
                      <div className="text-muted-foreground">{`x${addon.nextPaymentQuantity}`}</div>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
